import { Card } from "../_shared/card";
import { IconHeart } from "../_shared/icons";
import { actions } from "../_data/mock";

export function ActionsCard() {
  return (
    <Card
      title="Actions"
      icon={<IconHeart width={18} height={18} />}
      onClick={() => {}}
    >
      <ul className="space-y-1.5 text-[13px] text-[var(--text-2)]">
        {actions.map((a) => (
          <li key={a.id} className="flex items-start gap-2">
            <span
              aria-hidden
              className="mt-1.5 size-1 shrink-0 rounded-full bg-[var(--text-3)]"
            />
            <span className="leading-snug">{a.label}</span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="mt-3 inline-flex h-9 items-center rounded-full bg-[var(--text-1)] px-4 text-xs font-semibold text-[var(--surface-1)] transition active:scale-95"
      >
        Modifier la réponse
      </button>
    </Card>
  );
}
